/* global $ */
export default [
  '$rootScope',
  '$element',
  'storyService',
  'fnService',
  channelTogglesController,
]

function channelTogglesController($rootScope, $element, storyService, _fn) {
  const allAs = (val) => (col) => _fn.keyValBy((x) => x + '')((x) => val)(col)
  const storyChannelKeys = Object.keys(storyService.channels)

  this.chKeys = storyChannelKeys
  this.channelLabels = Object.assign({}, storyService.channels)
  this.$onInit = () => {
    this.contentElement = { channels: false }

    const unsubscribe = $rootScope.$on('el.requestChannelsModal', (evt, ce) => {
      this.contentElement = ce
      this.update()
      $('#channelTogglesModal').modal('show')
    })

    this.$onDestroy = () => {
      unsubscribe()
    }

    this.update()
  }

  this.update = () => {
    if (this.contentElement) {
      if (this.contentElement.channels) {
        let enabledChannels = allAs(true)(this.contentElement.channels)
        let allChannels = allAs(false)(storyChannelKeys)
        this.channels = Object.assign(allChannels, enabledChannels)
      } else {
        this.channels = allAs(true)(storyChannelKeys)
      }
    } else {
      this.channels = undefined
    }
  }

  this.adopt = () => {
    this.contentElement.channels = _fn.keysWhich((val) => val)(this.channels)
    this.update()
  }

  this.close = () => {
    this.contentElement = null
    this.update()
  }
}
